<nav class="nw-pagination" aria-label="Pagination">
    <button
        type="button"
        class="nw-pagination__button nw-pagination__button--nav"
        [disabled]="currentPage <= 1"
        (click)="goToPage(currentPage - 1)"
        aria-label="Go to previous page"
    >
        <nw-icon icon="chevron-left"></nw-icon>
    </button>

    @for (page of pages; track trackByPage($index, page)) {
        @if (page === '...') {
            <span class="nw-pagination__ellipsis" aria-hidden="true">...</span>
        } @else {
            <button
                type="button"
                class="nw-pagination__button"
                [class.nw-pagination__button--active]="page === currentPage"
                [attr.aria-current]="page === currentPage ? 'page' : null"
                (click)="goToPage(page)"
            >
                {{ page }}
            </button>
        }
    }

    <button
        type="button"
        class="nw-pagination__button nw-pagination__button--nav"
        [disabled]="currentPage >= totalPages"
        (click)="goToPage(currentPage + 1)"
        aria-label="Go to next page"
    >
        <nw-icon icon="chevron-right"></nw-icon>
    </button>
</nav>
